import SectionTitle from "@/components/ui/section-title";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import ImageCard from "../../ui/image_card/imgCard";
import LeftArrow from "@/components/ui/swiper/left-arrow";
import RightArrow from "@/components/ui/swiper/right-arrow";

import { MEDIA_BASE_URL } from "@/utils/api";
import Link from "next/link";

const Related_Collections = ({ relatedCollections }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  return (
    <section className="exploreCollection container" id="firstSection">
      <div className="flex flex-wrap justify-between items-center">
        <SectionTitle
          title={"Related Collection"}
          customClass={"mb-5 lg:mb-[2.5vw]"}
        />
        <div className="flex flex-[0_0_auto]">
          <LeftArrow
            customClass={
              "relative swiper-left-1 !left-0 lg:!left-0 mx-5 !translate-y-[0] !cursor-pointer"
            }
          />
          <RightArrow
            customClass={
              "relative swiper-right-1 !right-0 lg:!right-0 !translate-y-[0] !cursor-pointer"
            }
          />
        </div>
      </div>

      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        speed={3000}
        loop={false}
        navigation={{
          prevEl: ".swiper-left-1",
          nextEl: ".swiper-right-1",
        }}
        // autoplay={{
        //   delay: 500,
        //   disableOnInteraction: false,
        // }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        }}
        modules={[Navigation, Autoplay]}
        // className="h-full awardSlider"
      >
        {relatedCollections?.map((item, i) => (
          <SwiperSlide key={i} className="!h-auto">
            <Link
              href={`collection-landing?collection_name=${item.title}`}
              className="block h-full relative pb-6"
            >
              <ImageCard
                imgSrc={`${mediaBaseUrl}${item.image}`}
                title={item.title}
                customClass={
                  "text-black font-secondary relative left-0 bottom-0 text-center w-full"
                }
                imgClass={`h-full w-full object-cover`}
                parentClass={`h-[130px] sm:h-[180px] lg:h-[13.17vw] mb-4`}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Related_Collections;
